import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import * as bie from "react-bootstrap";
import { FaEye, FaRegTrashAlt } from 'react-icons/fa';
import { VscDiffAdded } from 'react-icons/vsc';
import { config } from '../../CommonUtils/CommonURLS';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { viewImage } from '../../CommonUtils/viewImage';
import moment from "moment";
import * as Yup from 'yup'

import Swal from 'sweetalert2';
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, allowNumbersAndAlphabetsOnly, handlePaste } from '../../CommonUtils/CommonValidations';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
export default function AfflCollegeBuildingRelatedApprovals() {
  const userId = sessionStorage.getItem('user_id')
  const acYear = sessionStorage.getItem('ac_year')

  const validationSchema = Yup.object({
    buildingIssuedBy: Yup.string().required(ERROR_MSG).nullable(),
    competentBodyApproved: Yup.string().required(ERROR_MSG).nullable(),
    buildingIssuedDate: Yup.string().required(ERROR_MSG).nullable(),
    deviationToApprovedBuildingPlan: Yup.string().required(ERROR_MSG).nullable(),
    bpsApplicationPending: Yup.string().required(ERROR_MSG),
    bpsApplicationNo: Yup.string().when('bpsApplicationPending', {
      is: 'Yes',
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().notRequired(),
    }),
    referenceNo: Yup.string().when('bpsApplicationPending', {
      is: 'Yes',
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().notRequired(),
    }),

    collegeBuildingPhoto: Yup.string().required(ERROR_MSG).nullable(),
    buildingPlanLicensedArchitect: Yup.string().required(ERROR_MSG).nullable(),
    occupancyIssuedBy: Yup.string().required(ERROR_MSG).nullable(),
    occupancyIssueDate: Yup.string().required(ERROR_MSG).nullable(),
    occupancyPlanFile: Yup.string().required(ERROR_MSG).nullable(),
    sanitaryCertificateBy: Yup.string().required(ERROR_MSG).nullable(),
    sanitaryIssueDate: Yup.mixed().required(ERROR_MSG).nullable(),
    sanitaryValidDate: Yup.string().required(ERROR_MSG).nullable(),
    sanitaryProvisionFile: Yup.string().required(ERROR_MSG).nullable(),
    structuralCertificateBy: Yup.string().required(ERROR_MSG).nullable(),
    structuralDateIssuance: Yup.string().required(ERROR_MSG).nullable(),
    structuralValidTill: Yup.string().required(ERROR_MSG).nullable(),
    structuralCertificate: Yup.mixed().required(ERROR_MSG).nullable(),
    fireBuildingHeight: Yup.string().required(ERROR_MSG).nullable(),
    fireCertificateIsAvailable: Yup.string().required(ERROR_MSG).nullable(),

    // fireNocIssuedUptoDate: Yup.date().when('fireCertificateIsAvailable', {
    //   is: 'No',
    //   then: Yup.string().required(ERROR_MSG),
    //   otherwise: Yup.date().notRequired(),
    // }),

    // fireValidTill: Yup.date().when('fireCertificateIsAvailable', {
    //   is: 'No',
    //   then: Yup.string().required(ERROR_MSG),
    //   otherwise: Yup.date().notRequired(),
    // }),

    fireNocIssuedUptoDate: Yup.string()
      .test('required', ERROR_MSG, value => value !== null && value !== '')
      .when('fireCertificateIsAvailable', {
        is: 'No',
        then: Yup.string().required(ERROR_MSG),
        otherwise: Yup.string().notRequired(),
      }),




    fireValidTill: Yup.string()
      .test('required', ERROR_MSG, value => value !== null && value !== '')
      .when('fireCertificateIsAvailable', {
        is: 'No',
        then: Yup.string().required(ERROR_MSG),
        otherwise: Yup.string().notRequired(),
      }),

    fireCertificateNo: Yup.string().when('fireCertificateIsAvailable', {
      is: 'No',
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().notRequired(),
    }),
    fireCertificateIssuedBy: Yup.string().when('fireCertificateIsAvailable', {
      is: 'No',
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().notRequired(),
    }),
    // fireValidTill: Yup.string().when('fireCertificateIsAvailable', {
    //   is: 'No',
    //   then: Yup.string().required(ERROR_MSG),
    //   otherwise: Yup.string().nullable(),
    // }),
    fireCertificateDoc: Yup.string().when('fireCertificateIsAvailable', {
      is: 'No',
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().notRequired(),
    }),
    bldApprovels: Yup.array().of(
      Yup.object().shape({
        proceedingApprovedBuildingPlans: Yup.string().required(ERROR_MSG).nullable(),
        approvedBuildingPlans: Yup.string().required(ERROR_MSG).nullable(),

      })
    ),


  });
  const ClgBldngAprvalFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      bldApprovels: [
        {
          proceedingApprovedBuildingPlans: "",
          approvedBuildingPlans: ""
        }
      ],

      buildingIssuedBy: "",
      competentBodyApproved: "",
      buildingIssuedDate: "",
      deviationToApprovedBuildingPlan: "",
      bpsApplicationPending: "",
      bpsApplicationNo: "",
      referenceNo: "",
      collegeBuildingPhoto: "",
      buildingPlanLicensedArchitect: "",
      occupancyIssuedBy: "",
      occupancyIssueDate: "",
      occupancyPlanFile: "",

      sanitaryCertificateBy: "",
      sanitaryIssueDate: "",
      sanitaryValidDate: "",
      sanitaryProvisionFile: "",
      structuralCertificateBy: "",
      structuralDateIssuance: "",
      structuralValidTill: "",
      structuralCertificate: "",

      fireBuildingHeight: "",
      fireCertificateIsAvailable: "",
      fireNocIssuedUptoDate: "",
      fireCertificateNo: "",
      fireCertificateIssuedBy: "",
      fireValidTill: "",
      fireCertificateDoc: "",

    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      Swal.fire({
        title: 'Are you sure want to submit ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Submit'
      }).then((result) => {
        if (result.isConfirmed) {
          let parsedHeight = parseInt(values?.fireBuildingHeight, 10);
          values.fireBuildingHeight = isNaN(parsedHeight) ? null : parsedHeight;
          let Referenceno = parseInt(values?.referenceNo, 10);
          values.referenceNo = isNaN(Referenceno) ? null : Referenceno;
          let url = config.url.API_URL + `CollegeBuildingRelatedApprovals`
          CommonAxiosPost(url, values).then((res) => {
            if (res?.data?.scode === '01') {
              successAlertRefresh(res?.data?.sdesc)
            }
            else {
              failureAlert(res?.data?.sdesc)
            }
          })

        }
      })

    }
  })
  const [ClgbldnAprvalData, setClgbldnAprvalData] = useState([]);
  const [ClgbldngPhoto, setClgbldngPhoto] = useState([]);

  function ClfBldAprlReport() {
    let url = config.url.API_URL + `getCollBuidingRelatedReport`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setClgbldnAprvalData(res?.data?.CollBuidingRelatedReport[0]);
        const bldngIssueDate = moment(res?.data?.CollBuidingRelatedReport[0]?.building_issued_date, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        const OccupancyIssueDate = moment(res?.data?.CollBuidingRelatedReport[0]?.occupancy_issued_date, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        const SanitaryIssueedDate = moment(res?.data?.CollBuidingRelatedReport[0]?.sanitary_issue_date, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        const SanitaryValidDate = moment(res?.data?.CollBuidingRelatedReport[0]?.sanitary_valid_date, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        const structuralDateIssuance = moment(res?.data?.CollBuidingRelatedReport[0]?.structural_date_issuance, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        const structuralValidTillDate = moment(res?.data?.CollBuidingRelatedReport[0]?.structural_valid_till, 'DD/MM/YYYY', true).format('YYYY-MM-DD');



        // const fireNocIssuedUptoDate = moment(res?.data?.CollBuidingRelatedReport[0]?.fire_noc_issued_upto_date, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        const uptoinputDate = res?.data?.CollBuidingRelatedReport[0]?.fire_noc_issued_upto_date;
        const formattedDateupto = moment(uptoinputDate, 'DD/MM/YYYY', true);
        const fireNocIssuedUptoDate = formattedDateupto.isValid() ? formattedDateupto.format('YYYY-MM-DD') : null;

        // const fireValidTillDate = moment(res?.data?.CollBuidingRelatedReport[0]?.fire_valid_till, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        const validinputDate = res?.data?.CollBuidingRelatedReport[0]?.fire_valid_till;
        const formattedDatevalidtill = moment(validinputDate, 'DD/MM/YYYY', true);
        const fireValidTillDate = formattedDatevalidtill.isValid() ? formattedDatevalidtill.format('YYYY-MM-DD') : null;
        // .................................
        ClgBldngAprvalFormik?.setFieldValue("buildingIssuedBy", res?.data?.CollBuidingRelatedReport[0]?.building_issued_by)
        ClgBldngAprvalFormik?.setFieldValue("buildingIssuedDate", bldngIssueDate ?? '')
        ClgBldngAprvalFormik?.setFieldValue("competentBodyApproved", res?.data?.CollBuidingRelatedReport[0]?.competent_body_approved?.toString() ?? "")
        ClgBldngAprvalFormik?.setFieldValue("deviationToApprovedBuildingPlan", res?.data?.CollBuidingRelatedReport[0]?.deviation_to_approved_building_plan)
        ClgBldngAprvalFormik?.setFieldValue("bpsApplicationPending", res?.data?.CollBuidingRelatedReport[0]?.bps_application_pending)
        ClgBldngAprvalFormik?.setFieldValue("bpsApplicationNo", res?.data?.CollBuidingRelatedReport[0]?.bps_application_no)
        ClgBldngAprvalFormik?.setFieldValue("referenceNo", res?.data?.CollBuidingRelatedReport[0]?.reference_no ? res?.data?.CollBuidingRelatedReport[0]?.reference_no : '')

        ClgBldngAprvalFormik?.setFieldValue("occupancyIssuedBy", res?.data?.CollBuidingRelatedReport[0]?.occupancy_issued_by)
        ClgBldngAprvalFormik?.setFieldValue("occupancyIssueDate", OccupancyIssueDate ?? '')
        ClgBldngAprvalFormik?.setFieldValue("sanitaryCertificateBy", res?.data?.CollBuidingRelatedReport[0]?.sanitary_certificate_by)
        ClgBldngAprvalFormik?.setFieldValue("sanitaryIssueDate", SanitaryIssueedDate ?? '')
        ClgBldngAprvalFormik?.setFieldValue("sanitaryValidDate", SanitaryValidDate ?? '')

        ClgBldngAprvalFormik?.setFieldValue("structuralCertificateBy", res?.data?.CollBuidingRelatedReport[0]?.structural_certificate_by)
        ClgBldngAprvalFormik?.setFieldValue("structuralDateIssuance", structuralDateIssuance ?? '')
        ClgBldngAprvalFormik?.setFieldValue("structuralValidTill", structuralValidTillDate ?? '')
        ClgBldngAprvalFormik?.setFieldValue("fireBuildingHeight", res?.data?.CollBuidingRelatedReport[0]?.fire_building_height)
        ClgBldngAprvalFormik?.setFieldValue("fireCertificateIsAvailable", res?.data?.CollBuidingRelatedReport[0]?.fire_certificate_is_available ?? '')

        ClgBldngAprvalFormik?.setFieldValue("fireNocIssuedUptoDate", fireNocIssuedUptoDate ?? '')
        ClgBldngAprvalFormik?.setFieldValue("fireCertificateNo", res?.data?.CollBuidingRelatedReport[0]?.fire_certificate_no)
        ClgBldngAprvalFormik?.setFieldValue("fireCertificateIssuedBy", res?.data?.CollBuidingRelatedReport[0]?.fire_certificate_issued_by)
        ClgBldngAprvalFormik?.setFieldValue("fireValidTill", fireValidTillDate ?? '')
        ClgBldngAprvalFormik?.setFieldValue("fireCertificateDoc", res?.data?.CollBuidingRelatedReport[0]?.fire_certificate_doc)
        ClgBldngAprvalFormik?.setFieldValue("sanitaryProvisionFile", res?.data?.CollBuidingRelatedReport[0]?.sanitary_provision_file)
        ClgBldngAprvalFormik?.setFieldValue("structuralCertificate", res?.data?.CollBuidingRelatedReport[0]?.structural_certificate)
        ClgBldngAprvalFormik?.setFieldValue("occupancyPlanFile", res?.data?.CollBuidingRelatedReport[0]?.occupancy_plan_file)
        ClgBldngAprvalFormik?.setFieldValue("collegeBuildingPhoto", res?.data?.CollBuidingRelatedReport[0]?.college_building_photo)
        ClgBldngAprvalFormik?.setFieldValue("buildingPlanLicensedArchitect", res?.data?.CollBuidingRelatedReport[0]?.building_plan_licensed_architect)
        setClgbldngPhoto(res?.data?.CollBuidingRelatedReport[0])

      }
      else {
        setClgbldnAprvalData([])
      }
    })
  }
  const [UploadedDocuments, setUploadedDocuments] = useState([]);
  function GetdocumentsUploaded() {
    let url = config.url.API_URL + "getCollBuidingRelatedApprovelReport";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setUploadedDocuments(res?.data?.CollBuidingRelatedApprovelReport)
        res?.data?.CollBuidingRelatedApprovelReport?.map((data, i) => {
          ClgBldngAprvalFormik?.setFieldValue(`bldApprovels[${i}].proceedingApprovedBuildingPlans`, data?.proceeding_approved_building_plans,);
          ClgBldngAprvalFormik?.setFieldValue(`bldApprovels[${i}].approvedBuildingPlans`, data?.approved_building_plans);
        })

      }
      else {
        setUploadedDocuments([])
      }
    })
  }
  useEffect(() => {
    ClfBldAprlReport();
    GetdocumentsUploaded();
  }, [])

  // Deleteproceedings file---------------------
  const Deleteproceedings = (sno) => {
    const proceedingpayload = {
      slno: sno,
    };
    Swal.fire({
      title: `Are you sure want to Delete the File?`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Not Delete",
    }).then((result) => {
      if (result.isConfirmed) {

        CommonAxiosPost(config.url.API_URL + "deleteCollegeBuildingRelatedApprovals", proceedingpayload).then((res) => {
          if (res.data.scode === "01") {
            successAlertRefresh(res.data.sdesc);

          } else {
            failureAlert(res.data.sdesc);
          }
        });
      }
    });

  };
  //   CLEAR FIELDS Functions.........
  function ClearBPS() {
    ClgBldngAprvalFormik.setFieldValue("bpsApplicationNo", "");
    ClgBldngAprvalFormik.setFieldValue("referenceNo", "");
  }
  function ClearBuildingNoc() {
    ClgBldngAprvalFormik.setFieldValue("fireNocIssuedUptoDate", "");
    ClgBldngAprvalFormik.setFieldValue("fireCertificateNo", "");
    ClgBldngAprvalFormik.setFieldValue("fireCertificateIssuedBy", "");
    ClgBldngAprvalFormik.setFieldValue("fireValidTill", "");
    ClgBldngAprvalFormik.setFieldValue("fireCertificateDoc", "");

  }
  return (
    <>
      <div className='aff-newdiv'>
        <CommonFormHeading heading="College Building Related Approvals" />
        <bie.Container fluid className="px-1" >

          <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
            <FormikProvider value={ClgBldngAprvalFormik}>
              <Form onChange={ClgBldngAprvalFormik.handleChange} onSubmit={ClgBldngAprvalFormik.handleSubmit} className="affl-form">
                <bie.Row className="px-2 pt-3 m-0">
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Competent Authority who has approved the Building Plan for the College:</b></label>
                      <Field as='select' name="buildingIssuedBy" className='form-control mb-2 down-marg5'>
                        <option value="">--Select--</option>
                        <option value="Panchayat">Panchayat</option>
                        <option value="Municipality">Municipality</option>
                        <option value="Urban_Development">Urban Development Authority</option>
                        <option value="Municipal_Corporation">Municipal Corporation</option>
                      </Field>
                      <ErrorMessage name="buildingIssuedBy" component="div" className="text-error" />
                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Name of the Competent Body that have approved Building Plan :</b></label>
                      <Field type='text' name="competentBodyApproved" className='form-control mb-2 down-marg5' onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }} maxLength="50" />
                      <ErrorMessage name="competentBodyApproved" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Date of Approval of Building Plan :</b></label>
                      <Field type='date' name="buildingIssuedDate" className='form-control down-marg6' onKeyDown={(e) => { e.preventDefault() }} min="1970-01-01" max={new Date().toISOString().split('T')[0]}></Field>
                      <ErrorMessage name="buildingIssuedDate" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Is any portion of the Building Unauthorized / Constructed in deviation to
                        the Approved Building Plan:</b></label>
                      <div className='form-control down-marg5'>
                        <Field type="radio" name="deviationToApprovedBuildingPlan" value="Yes" />&nbsp;Yes&emsp;
                        <Field type="radio" name="deviationToApprovedBuildingPlan" value="No" /> &nbsp; No
                        <ErrorMessage name="deviationToApprovedBuildingPlan" component="div" className="text-error" />
                      </div>

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Any BPS Application Pending for Consideration:</b></label>
                      <div className='form-control'>
                        <Field type="radio" name="bpsApplicationPending" value="Yes" />&nbsp;Yes&emsp;
                        <Field type="radio" name="bpsApplicationPending" value="No" onChange={(e) => { ClearBPS() }} /> &nbsp; No
                        <ErrorMessage name="bpsApplicationPending" component="div" className="text-error" />
                      </div>

                    </bie.Col>
                    {ClgBldngAprvalFormik?.values?.bpsApplicationPending === "Yes" ? (<>
                      <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                        <label classname='mb-1' ><b className='field-mandatory'>BPS Application Number :</b></label>
                        <Field type='text' name="bpsApplicationNo" className='form-control mb-2' onKeyPress={(e) => { allowNumbersAndAlphabetsOnly(e); }} maxLength="15" />
                        <ErrorMessage name="bpsApplicationNo" component="div" className="text-error" />

                      </bie.Col>
                      <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                        <label classname='mb-1' ><b className='field-mandatory'>Reference Number :</b></label>
                        <Field type='text' name="referenceNo" className='form-control mb-2' onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} maxLength="15"></Field>
                        <ErrorMessage name="referenceNo" component="div" className="text-error" />

                      </bie.Col>
                    </>) : (<></>)}
                  </bie.Row>

                </bie.Row>
                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">Upload Documents</h1></div>
                <div className="table-responsive">
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table mt-3">
                    <thead>
                      <tr>
                        <th>SNO</th>
                        <th>Proceedings of Approved Building Plans till date </th>
                        <th>Approved Building Plans till date  </th>
                        <th>Action</th>

                      </tr>
                    </thead>
                    <tbody>
                      <FieldArray name="bldApprovels">
                        {(QualificationValues) => {
                          return QualificationValues?.form?.values?.bldApprovels?.map((qual, index) => {
                            return (
                              <>
                                <tr key={index}>
                                  <td>
                                    <center>{index + 1}</center>
                                  </td>
                                  <td className='text-center'>
                                    <div className='d-flex align-items-center justify-content-center'>
                                      <input type="file" className="form-control w-50" name={`bldApprovels[${index}].proceedingApprovedBuildingPlans`} accept="application/pdf"
                                        onChange={(e) => {
                                          let fileVal = userId + "_" + acYear;
                                          let filename = fileVal + "proceedingApprovedBuildingPlans"
                                          let path = "/Uploads/AffiliationPDFs/2023/CollegeBuildingRelatedApprovals/"
                                          ImagePdfBucket(e, ClgBldngAprvalFormik, path, `bldApprovels[${index}].proceedingApprovedBuildingPlans`, filename, "pdf")
                                        }}
                                      />
                                      {/* {ClgBldngAprvalFormik.values.bldApprovels[index].proceedingApprovedBuildingPlans && <b type='button' className='text-primary' onClick={() => { viewImage(ClgBldngAprvalFormik.values.bldApprovels[index].proceedingApprovedBuildingPlans) }}>View</b>} */}
                                      {UploadedDocuments[index]?.proceeding_approved_building_plans && (
                                        <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(UploadedDocuments[index]?.proceeding_approved_building_plans); }}><FaEye size={23} /></button>
                                      )}
                                    </div>
                                    <ErrorMessage name={`bldApprovels[${index}].proceedingApprovedBuildingPlans`} component="div" className="text-error" />
                                  </td>

                                  <td>
                                    <div className='d-flex align-items-center justify-content-center'>
                                      <input type="file" className="form-control w-50" name={`bldApprovels[${index}].approvedBuildingPlans`} accept="application/pdf"
                                        onChange={(e) => {
                                          let fileVal = userId + "_" + acYear;
                                          let filename = fileVal + "approvedBuildingPlans"
                                          let path = "/Uploads/AffiliationPDFs/2023/CollegeBuildingRelatedApprovals/"
                                          ImagePdfBucket(e, ClgBldngAprvalFormik, path, `bldApprovels[${index}].approvedBuildingPlans`, filename, "pdf")
                                        }} />


                                      {UploadedDocuments[index]?.approved_building_plans && (
                                        <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(UploadedDocuments[index]?.approved_building_plans); }}><FaEye size={23} /></button>
                                      )}
                                      <ErrorMessage name={`bldApprovels[${index}].approvedBuildingPlans`} component="div" className="text-error" />
                                    </div>
                                  </td>
                                  <td colSpan={2} align="center" className="col-md-1">
                                    {(ClgBldngAprvalFormik.values.bldApprovels.length >= 2) ? (
                                      <button
                                        type="button"
                                        className="button-titile btn btn-sm btn-danger"
                                        onClick={() => QualificationValues.remove(index)} >
                                        <FaRegTrashAlt />
                                      </button>
                                    ) : <td></td>}

                                  </td>

                                </tr>
                              </>
                            );
                          });
                        }}
                      </FieldArray>

                      <tr className='table-active'>
                        <td align="right" colSpan={7} className='pe-3'>
                          <FieldArray name="bldApprovels">
                            {(formikFieldArray) => {
                              return formikFieldArray.form.values.bldApprovels.map((LJP, i) => {
                                return (<>
                                  {(i === 0) ? <> <button type="button" className="button-titile btn btn-sm btn-success me-4" style={{
                                    float: 'right',
                                  }}
                                    onClick={() => {
                                      formikFieldArray.push({
                                        proceedingApprovedBuildingPlans: "",
                                        approvedBuildingPlans: ""

                                      });
                                    }}>
                                    <VscDiffAdded></VscDiffAdded>
                                  </button> </> : ''}
                                </>)
                              })
                            }}
                          </FieldArray>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* {UploadedDocuments && UploadedDocuments.length > 0 ? (<>
                <bie.Row>
                  <table className="table table-condensed table-bordered table-striped table-hover">
                    <thead>
                      <tr style={{ height: '50px' }}>
                        <th> S.no </th>
                        <th>View For Uploaded Proceedings of Approved Building Plans till date</th>
                        <th> View For Uploaded Approved Building Plans till date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>

                      {UploadedDocuments && UploadedDocuments?.map((data, index) => (
                        <tr key={index}>
                          <td className='cen'>{index + 1}</td>
                          <td> {data?.proceeding_approved_building_plans && <b type='button' className='text-primary'
                            onClick={() => { viewImage(data?.proceeding_approved_building_plans) }}>View</b>}
                          </td>
                          <td> {data?.approved_building_plans && <b type='button' className='text-primary'
                            onClick={() => { viewImage(data?.approved_building_plans) }}>View</b>}
                          </td>
                          <td className='cen'> <button type='button' className='btn btn-danger btn-sm mt-2 '
                            onClick={() => { Deleteproceedings(data?.sl_no) }}> Delete  </button></td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </bie.Row>

              </>) : (<></>)} */}

                <bie.Row className="pt-3">

                  {/* ----------------- First Upload Field ----------------- */}
                  <bie.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5} className="mb-3">
                    <label className="mb-1">
                      <b className="field-mandatory">Latest Photograph of the College Building Certified by the Principal :</b>
                    </label>

                    <div className="d-flex align-items-center">
                      <input
                        type="file"
                        className="form-control"
                        name="collegeBuildingPhoto"
                        accept="application/pdf"
                        onChange={(e) => {
                          let fileVal = userId + "_" + acYear;
                          let filename = fileVal + "collegeBuildingPhoto";
                          let path = "/Uploads/AffiliationPDFs/2023/CollegeBuildingRelatedApprovals/";
                          ImagePdfBucket(e, ClgBldngAprvalFormik, path, "collegeBuildingPhoto", filename, "pdf");
                        }}
                      />

                      {ClgbldngPhoto?.college_building_photo && (
                        <button
                          type="button"
                          className="btn btn-primary ms-2"
                          onClick={() => viewImage(ClgbldngPhoto?.college_building_photo)}
                          style={{ height: "38px", width: "40px", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >
                          <FaEye size={20} />
                        </button>
                      )}
                    </div>

                    <ErrorMessage name="collegeBuildingPhoto" component="div" className="text-error" />
                  </bie.Col>

                  {/* ----------------- Second Upload Field ----------------- */}
                  <bie.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5} className="mb-3">
                    <label className="mb-1">
                      <b className="field-mandatory">
                        Existing Plan Of The Building Drawn To Scale By Licensed Architect And Certified By The Principal (.Pdf Only):
                      </b>
                    </label>

                    <div className="d-flex align-items-center">
                      <input
                        type="file"
                        className="form-control"
                        name="buildingPlanLicensedArchitect"
                        accept="application/pdf"
                        onChange={(e) => {
                          let fileVal = userId + "_" + acYear;
                          let filename = fileVal + "buildingPlanLicensedArchitect";
                          let path = "/Uploads/AffiliationPDFs/2023/CollegeBuildingRelatedApprovals/";
                          ImagePdfBucket(e, ClgBldngAprvalFormik, path, "buildingPlanLicensedArchitect", filename, "pdf");
                        }}
                      />

                      {ClgbldngPhoto?.building_plan_licensed_architect && (
                        <button
                          type="button"
                          className="btn btn-primary ms-2"
                          onClick={() => viewImage(ClgbldngPhoto?.building_plan_licensed_architect)}
                          style={{ height: "38px", width: "40px", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >
                          <FaEye size={20} />
                        </button>
                      )}
                    </div>

                    <ErrorMessage name="buildingPlanLicensedArchitect" component="div" className="text-error" />
                  </bie.Col>

                </bie.Row>

                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0"> Occupancy/Building Completion Certificate</h1></div>
                <bie.Row className="px-2 pt-3 m-0 ">
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Issued By:</b></label>
                      <Field type='text' name="occupancyIssuedBy" className='form-control affl-margin ' onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }} maxLength="30" />
                      <ErrorMessage name="occupancyIssuedBy" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Issued Date:</b></label>
                      <Field type='date' name="occupancyIssueDate" className='form-control affl-margin ' onKeyDown={(e) => { e.preventDefault() }}
                        max={new Date().toISOString().split('T')[0]}
                        min={ClgBldngAprvalFormik?.values?.buildingIssuedDate} />
                      <ErrorMessage name="occupancyIssueDate" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Upload latest Occupancy certificate
                        issued by Competent Authorities (All the Building blocks should be covered)</b></label>
                      <div className="d-flex align-items-center">

                        <input type="file" className="form-control" name="occupancyPlanFile" accept="application/pdf"
                          onChange={(e) => {
                            let fileVal = userId + "_" + acYear;
                            let filename = fileVal + "occupancyPlanFile"
                            let path = "/Uploads/AffiliationPDFs/2023/CollegeBuildingRelatedApprovals/"
                            ImagePdfBucket(e, ClgBldngAprvalFormik, path, "occupancyPlanFile", filename, "pdf")
                          }}
                        />
                        <ErrorMessage name="occupancyPlanFile" component="div" className="text-error" />

                        {ClgbldngPhoto?.occupancy_plan_file && <button type='button' className='btn btn-primary' onClick={() => { viewImage(ClgbldngPhoto?.occupancy_plan_file) }}><FaEye size={23} /></button>}
                      </div>

                    </bie.Col>
                  </bie.Row>
                </bie.Row>

                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">Sanitary Certificate</h1></div>
                <bie.Row className="px-2 pt-3 m-0 ">
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={5} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Sanitary Certificate issued by Competent
                        Authority(CMOH/Medical Officer/ Municipal Health Officer)</b></label>
                      <Field type='text' name="sanitaryCertificateBy" className='form-control ' maxLength="50" onKeyPress={(e) => {
                        allowAlphabetAndSpacesOnly(e);
                      }} />
                      <ErrorMessage name="sanitaryCertificateBy" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Date of Issuance</b></label>
                      <Field type='date' name="sanitaryIssueDate" className='form-control ' onKeyDown={(e) => { e.preventDefault() }} min="1970-01-01" max={new Date().toISOString().split('T')[0]}></Field>
                      <ErrorMessage name="sanitaryIssueDate" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Valid Till</b></label>
                      <Field type='date' name="sanitaryValidDate" className='form-control ' onKeyDown={(e) => { e.preventDefault() }} min={new Date().toISOString().split('T')[0]} />
                      <ErrorMessage name="sanitaryIssueDate" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={5} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Upload (Latest Sanitary
                        Certificate Issued by Competent Authority)* : (.pdf only)</b></label>
                      <div className="d-flex align-items-center">

                        <input type="file" className="form-control affl-margin" name="sanitaryProvisionFile" accept="application/pdf"
                          onChange={(e) => {
                            let fileVal = userId + "_" + acYear;
                            let filename = fileVal + "sanitaryProvisionFile"
                            let path = "/Uploads/AffiliationPDFs/2023/CollegeBuildingRelatedApprovals/"
                            ImagePdfBucket(e, ClgBldngAprvalFormik, path, "sanitaryProvisionFile", filename, "pdf")
                          }}
                        />
                        <ErrorMessage name="sanitaryProvisionFile" component="div" className="text-error" />

                        {ClgbldngPhoto?.sanitary_provision_file && <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(ClgbldngPhoto?.sanitary_provision_file) }}><FaEye size={23} /></button>}
                      </div>
                    </bie.Col>
                  </bie.Row>
                </bie.Row>
                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">Structural Stability Certificate</h1></div>
                <bie.Row className="px-2 pt-3 m-0 ">
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={5} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Structural Stability Certificate issued
                        by Competent Authority</b></label>
                      <Field type='text' name="structuralCertificateBy" className='form-control mt-3' onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} maxLength="50" />

                      <ErrorMessage name="structuralCertificateBy" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2 '>
                      <label classname='mb-1' ><b className='field-mandatory'>Date of Issuance</b></label>
                      <Field type='date' name="structuralDateIssuance" className='form-control mt-3' min="1970-01-01" onKeyPress={(e) => { e.preventDefault() }} max={new Date().toISOString().split('T')[0]}>

                      </Field>
                      <ErrorMessage name="structuralDateIssuance" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Valid Till</b></label>
                      <Field type='date' name="structuralValidTill" className='form-control mt-3' onKeyDown={(e) => { e.preventDefault() }} min={new Date().toISOString().split('T')[0]} />

                      <ErrorMessage name="structuralValidTill" component="div" className="text-error" />

                    </bie.Col>

                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={5} xxl={3} className='mb-2'>

                      <label classname='mb-1' ><b className='field-mandatory'>Upload (Latest Structural Stability Certificate
                        Issued by Competent Authority)* : (.pdf only)</b></label>
                      <div className="d-flex align-items-center">

                        <input type="file" className="form-control" name="structuralCertificate" accept="application/pdf"
                          onChange={(e) => {
                            let fileVal = userId + "_" + acYear;
                            let filename = fileVal + "structuralCertificate"
                            let path = "/Uploads/AffiliationPDFs/2023/CollegeBuildingRelatedApprovals/"
                            ImagePdfBucket(e, ClgBldngAprvalFormik, path, "structuralCertificate", filename, "pdf")
                          }}
                        />
                        <ErrorMessage name="structuralCertificate" component="div" className="text-error" />

                        {ClgbldngPhoto?.structural_certificate && <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(ClgbldngPhoto?.structural_certificate) }}><FaEye size={23} /></button>}
                      </div>
                    </bie.Col>
                  </bie.Row>
                </bie.Row>
                <div className="inner-herbpage-service-title-sub">
                  <h1 className="">Fire Safety Certificate (This shall be provided for all the Building blocks available)</h1></div>
                <bie.Row className="px-2 pt-3 m-0  ">
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Height of the College Building in Mtrs</b></label>
                      <Field type='text' name="fireBuildingHeight" className='form-control mt-3' onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength="4" onPaste={(e) => handlePaste(e)}>

                      </Field>
                      <ErrorMessage name="fireBuildingHeight" component="div" className="text-error" />

                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                      <label classname='mb-1' ><b className='field-mandatory'>Is the College Building Exempted from
                        obtaining the Fire NOC?</b></label>
                      <Field type="radio" name="fireCertificateIsAvailable" value="Yes" onChange={(e) => { ClearBuildingNoc() }}
                      />&nbsp;Yes&emsp;
                      <Field type="radio" name="fireCertificateIsAvailable" value="No" /> &nbsp; No
                      <ErrorMessage name="fireCertificateIsAvailable" component="div" className="text-error" />

                    </bie.Col>
                    {ClgBldngAprvalFormik?.values?.fireCertificateIsAvailable === "No" ? (<>
                      <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                        <label classname='mb-1' ><b className='field-mandatory'>Date of the Latest Fire
                          NOC issued by the Competent Authority</b></label>
                        <Field type='date' name="fireNocIssuedUptoDate" className='form-control mb-2' onKeyDown={(e) => { e.preventDefault() }} min="1970-01-01" max={new Date().toISOString().split('T')[0]}>

                        </Field>
                        <ErrorMessage name="fireNocIssuedUptoDate" component="div" className="text-error" />

                      </bie.Col>

                      <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                        <label classname='mb-1' ><b className='field-mandatory'>Certificate Number</b></label>
                        <Field type='text' name="fireCertificateNo" className='form-control' maxLength="10" onKeyPress={(e) => { allowNumbersAndAlphabetsOnly(e); }} />
                        <ErrorMessage name="fireCertificateNo" component="div" className="text-error" />

                      </bie.Col>
                      <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                        <label classname='mb-1' ><b className='field-mandatory'>Certificate Issued by</b></label>
                        <Field type='text' name="fireCertificateIssuedBy" className='form-control mt-3' onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />


                        <ErrorMessage name="fireCertificateIssuedBy" component="div" className="text-error" />

                      </bie.Col>
                      <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                        <label classname='mb-1' ><b className='field-mandatory'>Valid Till Date</b></label>
                        <Field type='date' name="fireValidTill" className='form-control mt-3' onKeyDown={(e) => { e.preventDefault() }} min={new Date().toISOString().split("T")[0]} />


                        <ErrorMessage name="fireValidTill" component="div" className="text-error" />

                      </bie.Col>

                      <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                        <label classname='mb-1' ><b className='field-mandatory'>Upload the Latest NOC issued by Fire Prevention Wing :</b></label>
                        <div className="d-flex align-items-center">

                          <input type="file" className="form-control" name="fireCertificateDoc" accept="application/pdf"
                            onChange={(e) => {
                              let fileVal = userId + "_" + acYear;
                              let filename = fileVal + "fireCertificateDoc"
                              let path = "/Uploads/AffiliationPDFs/2023/CollegeBuildingRelatedApprovals/"
                              ImagePdfBucket(e, ClgBldngAprvalFormik, path, "fireCertificateDoc", filename, "pdf")
                            }}
                          />
                          <ErrorMessage name="fireCertificateDoc" component="div" className="text-error" />

                          {ClgBldngAprvalFormik?.values?.fireCertificateDoc && <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(ClgBldngAprvalFormik?.values?.fireCertificateDoc) }}><FaEye size={23} /></button>}

                        </div>
                      </bie.Col>
                    </>) : (<></>)}
                  </bie.Row>

                </bie.Row>
                <button type='submit' className='btn btn-success btn-sm mt-2 float-end'>Submit</button>

              </Form>
            </FormikProvider>
          </bie.Container>
        </bie.Container>
      </div >

    </>
  )
}
